import { ChevronDownIcon } from '@eventbrite/marmalade';
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import LocationAutocompleteContainer from '../../../../../containers/LocationAutocompleteContainer/LocationAutocompleteContainer';
import { DiscoverState } from '../../../../../types';
import './LocationPickerContainer.scss';

const LOCATION_AUTOCOMPLETE_PROPS = {
    borderType: 'content',
    id: 'locationPicker',
    name: 'locationPicker',
    hideOutline: true,
    isLimitedSearch: true,
    preventInputValuePrefill: true,
    shouldRemoveConflictiveAria: true,
};

const chevronIcon = <ChevronDownIcon color="#3659e3" />;

interface SearchPageParams {
    locale?: string;
    locationSlug: string;
    query: string;
}

interface DSRPLocationComponentProps
    extends RouteComponentProps<SearchPageParams> {
    currentPlace: string;
}

const DSRPLocationComponent = ({
    currentPlace,
    match,
    history,
}: DSRPLocationComponentProps) => {
    const [displayedLocation, setDisplayedLocation] = useState(currentPlace);
    const handleLocationChange = useCallback(
        ({ slug, currentPlace }: { slug: string; currentPlace: string }) => {
            setDisplayedLocation(currentPlace);

            const {
                params: { locale, query },
            } = match;

            const localeParam = locale ? `/${locale}` : '';
            const locationParam = slug || 'online';
            const queryParam = query || 'all-events';

            history.push(`${localeParam}/d/${locationParam}/${queryParam}`);
        },
        [match, history, setDisplayedLocation],
    );

    return (
        <div className="dsrp-location">
            <span
                style={
                    {
                        '--character-count': displayedLocation?.length || 10,
                    } as any
                }
            >
                <LocationAutocompleteContainer
                    autocompleteProps={LOCATION_AUTOCOMPLETE_PROPS}
                    handleLocationSelect={handleLocationChange}
                    suffix={chevronIcon}
                />
            </span>
        </div>
    );
};

const _mapStateToProps = (state: DiscoverState) => ({
    currentPlace: state.location.currentPlace,
});

const enhance = compose<any>(withRouter, connect(_mapStateToProps));

export const LocationPickerContainer = enhance(DSRPLocationComponent);
